import { render, staticRenderFns } from "./SourceUsageTable.vue?vue&type=template&id=504b551f"
import script from "./SourceUsageTable.vue?vue&type=script&lang=js"
export * from "./SourceUsageTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports